import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { putPaymentAction } from 'src/redux/actions/paymentActions';
import { PAYMENT_STATUS } from 'src/models/PaymentModel';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment-timezone-all';
import Row from 'src/components/UI/Row';
import BottomRow from 'src/components/UI/BottomRow';
import Form from 'src/components/UI/Form';
import { MODALS_SIZE } from 'src/models/modal';

const RetryPaymentDialog = () => {
  const dispatch = useAppDispatch();

  const opened =
    useSelector((state: Store) => state.dialog[DIALOGS.retryPayments]?.opened || false);
  const payload =
    useSelector((state: Store) => state.dialog[DIALOGS.retryPayments]?.payload || []);

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleClose = () => {
    dispatch(closeDialog({ dialog: DIALOGS.retryPayments }));
  };

  const buildInvoiceItems = (payment: any) => {
    const invoices = payment.invoices ?? [];
    const totalAmount = Number(payment.amount) ?? 0;
    if (invoices.length === 1) {
      return [{ invoice_id: invoices[0].id, amount: totalAmount }];
    }
    let remaining = totalAmount;
    return invoices.reduce((items: any[], invoice: any) => {
      if (remaining <= 0) return items;
      const allocated = (invoice.balance ?? 0) < remaining ? invoice.balance : remaining;
      remaining -= allocated;
      items.push({ invoice_id: invoice.id, amount: allocated });
      return items;
    }, []);
  };

  const handleConfirm = () => {
    payload.forEach((payment: any) => {
      if (!payment) return;
      dispatch(putPaymentAction(payment.id, {
        ...payment,
        payment_status: PAYMENT_STATUS.scheduled,
        scheduled_date: moment().startOf('day'),
        paid_date: null,
        processed_date: null,
        invoices: buildInvoiceItems(payment),
      }));
    });
    handleClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="retry-payment"
      open={opened}>
      <DialogTitle id="retry-payment">{t(lang, 'forms.payments.retry_payment')}</DialogTitle>
      <DialogContent dividers>
        <Form maxWidth={MODALS_SIZE.large}>
          <Row>
            {t(lang, 'misc.retry_payment_confirmation')}
          </Row>
          <BottomRow style={{ alignItems: 'top' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: '24px 0px 16px' }}
              onClick={handleClose}>
              {t(lang, 'misc.cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: '24px 0px 16px' }}
              onClick={handleConfirm}>
              {t(lang, 'misc.retry_payments')}
            </Button>
          </BottomRow>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default RetryPaymentDialog;
